import { IconWrapper } from '../runtime';
export default IconWrapper('microphone', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M12.9453 8.74185C12.5868 11.1513 10.5093 12.9998 7.99999 12.9998M7.99999 12.9998C5.49073 12.9998 3.41319 11.1513 3.05469 8.74185M7.99999 12.9998V14.9998M7.99999 9.99976C6.89543 9.99976 5.99999 9.10433 5.99999 7.99976V2.99976C5.99999 1.89519 6.89543 0.999756 7.99999 0.999756C9.10456 0.999756 9.99999 1.89519 9.99999 2.99976V7.99976C9.99999 9.10433 9.10456 9.99976 7.99999 9.99976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});